angular.module('dnecom.component.currency')
    .service('CurrencyConverter', function() {
        return {
            convert: function(baseAmount, currencyRate) {
                if (!window.ies.store.currency.enabled) {
                    return baseAmount;
                }

                return baseAmount * currencyRate;
            }
        };
    });

